import React from 'react'
// @ts-ignore
import { Sparkline } from '@netbasequid/chart'
import { Status } from 'features/types'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import MeasureType, { MeasureTypeStrings } from 'enums/MeasureType'
import { MessageConst } from 'enums'
import Overview from '../index'

export const measureToSparklineColorMap: Partial<Record<MeasureTypeStrings, string>> = {
  [MeasureType.MENTIONS]: 'metric.mainMetrics.mentions',
  [MeasureType.POSTS]: 'metric.mainMetrics.post',
  [MeasureType.NET_SENTIMENT]: 'metric.mainMetrics.netSentiment',
  [MeasureType.IMPRESSIONS]: 'metric.mainMetrics.potentialImpressions',
  [MeasureType.PASSION_INTENSITY]: 'metric.mainMetrics.passionIntensity',
  [MeasureType.POSITIVES]: 'semantic.positive',
  [MeasureType.NEGATIVES]: 'semantic.negative',
  [MeasureType.UNIQUE_AUTHORS]: 'metric.mainMetrics.authors',
  [MeasureType.ENGAGEMENTS]: 'metric.mainMetrics.totalEngagement',
  [MeasureType.COMMENTS]: 'metric.subMetrics.totalEngagement.comments',
  [MeasureType.LIKES]: 'metric.subMetrics.totalEngagement.likes',
  [MeasureType.SHARES]: 'metric.subMetrics.totalEngagement.shares',
  [MeasureType.VIEWS]: 'metric.subMetrics.totalEngagement.views',
  [MeasureType.SCORE]: 'metric.subMetrics.totalEngagement.score',
  [MeasureType.ENGAGEMENT_RATIO_ONLY]: 'metric.mainMetrics.engagementsPerPost',
  [MeasureType.OVERALL_STAR_RATINGS_AVERAGE]: 'metric.mainMetrics.overallStarRatings',
  [MeasureType.OVERALL_SURVEY_SCORES_AVERAGE]: 'metric.mainMetrics.overallSurveyScores'
}

type SparklineOverviewProps = {
  title: React.ReactNode
  displayTitleTooltip?: boolean
  titleTooltipContent?: string
  measureType: MeasureTypeStrings
  count?: number | string
  sparklineData?: number[]
  percent?: string | undefined
  customizedInfo?: React.ReactNode
  status: Status
  testId?: string
}

const SparklineOverview = ({
  title,
  displayTitleTooltip = false,
  titleTooltipContent,
  measureType,
  count,
  sparklineData,
  percent,
  customizedInfo,
  status,
  testId
}: SparklineOverviewProps) => {
  const theme = useDisplayTheme() as Theme
  const sparklineColor = measureToSparklineColorMap[measureType]
  const sparklineThreshold = measureType === MeasureType.NET_SENTIMENT ? -Infinity : 0

  return (
    <Overview
      title={title}
      displayTitleTooltip={displayTitleTooltip}
      titleTooltipContent={titleTooltipContent}
      count={count}
      percent={percent}
      customizedInfo={customizedInfo}
      status={status}
      testId={testId}
      rightContent={
        count !== MessageConst.ONE_PLUS && (
          <Sparkline
            mode={theme}
            colorSettings={sparklineColor}
            data={sparklineData || []}
            threshold={sparklineThreshold}
          />
        )
      }
    />
  )
}

export default SparklineOverview
